// store/slices/modalSlice.ts

import { ReactNode } from "react";

export interface ModalState {
  modal: {
    isOpen: boolean;
    content: ReactNode | null;
    modalName: string | null;
    modalProps: any;
    mailchimpApiKeyModalClosed: boolean;
  };
}

export interface ModalActions {
  openModal: ({
    content,
    modalName,
    modalProps,
  }: {
    content?: ReactNode;
    modalName?: string | null;
    modalProps?: any;
  }) => void;
  closeModal: () => void;
  setMailchimpApiKeyModalClosed: (closed: boolean) => void;
}

export const modalSlice = (
  set: any,
): { data: ModalState; actions: ModalActions } => ({
  data: {
    modal: {
      isOpen: false,
      content: null,
      modalName: null,
      modalProps: {},
      mailchimpApiKeyModalClosed: false,
    },
  },
  actions: {
    openModal: ({
      content,
      modalName,
      modalProps,
    }: {
      content?: ReactNode;
      modalName?: string | null;
      modalProps?: any;
    }) => {
      set((state: any) => {
        state.data.modal.isOpen = true;
        state.data.modal.content = content ?? null;
        state.data.modal.modalName = modalName ?? null;
        state.data.modal.modalProps = modalProps ?? {};
      });
    },
    closeModal: () => {
      set((state: any) => {
        state.data.modal.isOpen = false;
        state.data.modal.content = null;
        state.data.modal.modalName = null;
      });
    },
    setMailchimpApiKeyModalClosed: (closed: boolean) => {
      set((state: any) => {
        state.data.modal.mailchimpApiKeyModalClosed = closed;
      });
    },
  },
});
